<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import { mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Posts",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    DropzonePopup,
  },
  data() {
    return {
      post: {
        id: "",
        visibility: "",
        post_description: "",
        website_url: "",
        type: "",
        image: "",
        video: "",
        file: "",
        question: "",
        options: [],
        status: true,
      },
      imagesSeen: "none",
      videoSeen: "none",
      fileSeen: "none",
      pollSeen: "none",
      isActive: false,
      planName: "",
      option1: false,
      option2: false,
      color: {
        "text-danger": true,
      },
      title: "Posts",
      optionInputs: ["", ""],
    };
  },
  validations: {
    post: {
      post_description: {
        required: requiredIf(function (data) {
          return data.type !== "Poll";
        }),
        minLength: minLength(3),
        maxLength: maxLength(8000),
      },
      visibility: { required },
      question: {
        required: requiredIf(function (data) {
          return data.type == "Poll";
        }),
      },
      options: {
        required: requiredIf(function (data) {
          return data.type == "Poll";
        }),
      },
    },
  },
  computed: mapGetters("post", [
    "loading",
    "postCount",
    "postData",
    "posts",
    "paginations",
  ]),
  mounted() {
    let userRole = JSON.parse(localStorage.getItem("user"));
    this.planName = userRole.plan_name;
  },
  methods: {
    ...mapActions("post", ["createPost"]),
    create() {
      this.$v.post.$touch();
      if (this.post.type == "Poll") {
        if (this.post.options[0] == "" || !this.post.options[0]) {
          this.option1 = true;
          return;
        } else {
          this.option1 = false;
        }
        if (this.post.options[1] == "" || !this.post.options[1]) {
          this.option2 = true;
          return;
        } else {
          this.option2 = false;
        }
      }
      if (this.$v.post.$invalid) {
        this.isActive = false;
        return;
      } else {
        this.isActive = true;
        var data = this.post;
        this.createPost(data).then((res) => {
          if (res == true) {
            this.isActive = true;
            this.$router.push({ name: "post.list" });
          } else {
            this.isActive = false;
          }
        });
      }
    },
    onChange(event) {
      this.value = event.target.value;
      if (this.value === "Image") {
        this.imagesSeen = "block";
        this.videoSeen = "none";
        this.fileSeen = "none";
        this.pollSeen = "none";
      } else if (this.value === "Video") {
        this.imagesSeen = "none";
        this.videoSeen = "block";
        this.fileSeen = "none";
        this.pollSeen = "none";
      } else if (this.value == "Poll") {
        this.pollSeen = "block";
        this.imagesSeen = "none";
        this.videoSeen = "none";
        this.fileSeen = "none";
      } else {
        this.imagesSeen = "none";
        this.videoSeen = "none";
        this.pollSeen = "none";
        this.fileSeen = "block";
      }
    },
    handleFileUpload() {
      let videoCanvas = document.getElementById("canvas");
      let video = document.getElementById("video");
      videoCanvas
        .getContext("2d")
        .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    },
    optionAdd() {
      this.optionInputs.push("");
    },
    optionRemove(index) {
      this.optionInputs.splice(index, 1);
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="text-left mb-4">
          <a href="#" class="router-link-active" @click="$router.back()">
            <i class="bx bx-arrow-back"></i>
            Back
          </a>
        </div>
        <div class="card">
          <div class="card-header">
            <div
              class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
            >
              <div class="page-title-left avatar-main-icon" style="display: flex">
                <div class="avatar-xs mr-3">
                  <span
                    class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                  >
                    <i class="bx bx-user-circle"></i>
                  </span>
                </div>
                <div class="report-tag">
                  <h4 class="mb-0 font-size-18">ADD POSTS</h4>
                  <p>
                    <router-link :to="{ name: 'post.list' }">Post </router-link>
                    > Add Post
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="create">
              <div class="row">
                <div class="col-12 mb-2">
                  <div class="form-group">
                    <label>Description<span :class="color">*</span></label>
                    <textarea
                      rows="5"
                      cols="159"
                      name="about"
                      v-model="post.post_description"
                      class="form-control"
                      :class="{ 'is-invalid': $v.post.post_description.$error }"
                      placeholder="Description"
                    ></textarea>
                    <div v-if="$v.post.post_description.$error" class="invalid-feedback">
                      <span v-if="!$v.post.post_description.required">
                        Please enter Description</span
                      >
                      <span v-if="!$v.post.post_description.minLength">
                        Description should not less than 3</span
                      >
                      <span v-if="!$v.post.post_description.maxLength">
                        Description should not more than 8000</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <b-form-group
                    id="website-group"
                    :label="
                      this.planName == 'Company Investor Relations Account'
                        ? 'Link Investor Relation Site'
                        : 'Website Link'
                    "
                    label-for="website"
                  >
                    <b-form-input
                      id="website_url"
                      name="website_url"
                      v-model="post.website_url"
                      type="url"
                      :placeholder="
                        this.planName == 'Company Investor Relations Account'
                          ? 'Enter link investor relation site'
                          : 'website link'
                      "
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Visibility<span :class="color">*</span></label>
                    <select
                      class="form-select form-control"
                      v-model="post.visibility"
                      name="visibility"
                      :class="{ 'is-invalid': $v.post.visibility.$error }"
                    >
                      <option value="" disabled>Select Type</option>
                      <option value="1">Anyone</option>
                      <option value="0">Followers Only</option>
                    </select>
                    <div v-if="$v.post.visibility.$error" class="invalid-feedback">
                      <span v-if="!$v.post.visibility.required">
                        Please select visibility</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Select Types</label>
                    <select
                      class="form-select form-control"
                      v-model="post.type"
                      name="visibility"
                      @change="onChange($event)"
                    >
                      <option value="" disabled>Text</option>
                      <option value="Image">Images</option>
                      <option value="Video">Video</option>
                      <option value="File">File</option>
                      <option value="Poll">Poll</option>
                    </select>
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Status</label>
                    <b-form-checkbox
                      switch
                      size="lg"
                      v-model="post.status"
                      class="ml-1"
                    ></b-form-checkbox>
                  </div>
                </div>

                <!-- Poll -->
                <div class="col-6 mb-2" :style="{ display: pollSeen }">
                  <div class="form-group">
                    <label>Question<span :class="color">*</span></label>
                    <textarea
                      rows="5"
                      cols="159"
                      name="about"
                      v-model="post.question"
                      class="form-control"
                      :class="{ 'is-invalid': $v.post.question.$error }"
                      placeholder="Question"
                    ></textarea>
                    <div v-if="$v.post.question.$error" class="invalid-feedback">
                      <span>Please enter question</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div v-for="(value, index) in optionInputs" :key="index" class="mt-1">
                      <label
                        >Option {{ index + 1
                        }}<span :class="color" v-if="index < 2">*</span></label
                      >
                      <div class="row">
                        <div class="col-10">
                          <input
                            type="text"
                            class="form-control"
                            v-model="post.options[index]"
                            placeholder="Add option"
                            :class="{
                              'is-invalid':
                                $v.post.options.$error ||
                                (option1 && index == 0) ||
                                (option2 && index == 1),
                            }"
                          />
                          <div
                            v-if="
                              $v.post.options.$error ||
                              (option1 && index == 0) ||
                              (option2 && index == 1)
                            "
                            class="invalid-feedback"
                          >
                            <span>Please enter option</span>
                          </div>
                          <!-- <div v-if="$v.post.options.$error || (option2 && index==1)" class="invalid-feedback">
                              <span>Please enter option</span>
                            </div> -->
                        </div>
                        <div
                          class="col-2 d-flex align-items-center justify-content-center"
                        >
                          <span>
                            <i
                              class="fas fa-minus-circle optionremove"
                              @click="optionRemove(index)"
                              v-show="index > 1"
                            ></i>
                            <i
                              class="fas fa-plus-circle optionadd"
                              @click="optionAdd(index)"
                              v-show="
                                index == optionInputs.length - 1 &&
                                optionInputs.length < 4
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- imagesSeen -->
                <div
                  class="col-6 mb-2"
                  :style="{
                    display: imagesSeen,
                  }"
                >
                  <div class="form-group">
                    <label>Images<span :class="color">*</span></label>
                    <dropzone-popup
                      v-model="post.image"
                      id="image"
                      name="image"
                      multiple
                      acceptedFiles="image/*"
                    />
                    <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
                  </div>
                </div>

                <!-- videoSeen -->
                <div
                  class="col-6 mb-2"
                  :style="{
                    display: videoSeen,
                  }"
                >
                  <div class="form-group">
                    <label>Video<span :class="color">*</span></label>
                    <dropzone-popup
                      v-model="post.video"
                      id="video"
                      name="video"
                      acceptedFiles=".mp4"
                    />
                    <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
                  </div>
                </div>

                <!-- fileSeen -->
                <div
                  class="col-6 mb-2"
                  :style="{
                    display: fileSeen,
                  }"
                >
                  <div class="form-group">
                    <label>File<span :class="color">*</span></label>
                    <dropzone-popup
                      v-model="post.file"
                      id="file"
                      thumbnailMethod="crop"
                      name="file"
                      acceptedFiles="application/pdf"
                      previewsContainer=".dropzone-previews"
                    />

                    <!-- .doc,.docx,.xls,.xlsx,.csv,.ppt,.odt -->
                    <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
                  </div>
                </div>

                <div class="col-12 pt-4">
                  <button type="submit" class="btn btn-primary" :disabled="isActive">
                    Post
                  </button>
                  <b-button
                    @click="$router.back()"
                    type="button"
                    variant="secondary"
                    class="ml-3"
                    >Cancel
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.form-select {
  -moz-padding-start: calc(0.75rem - 3px);
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url(/images/download.svg);
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  display: block;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
}
.optionadd {
  padding: 5px;
  font-size: 20px;
  color: green;
}
.optionremove {
  padding: 0px;
  font-size: 20px;
  color: red;
}
</style>
